import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { ScanLine } from 'lucide-react';
import { Logo } from '../components/ds';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";
const FONT_MONO = "'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, monospace";

const STATS = [
  ['27', 'Anforderungen'],
  ['6', 'Themenbereiche'],
  ['~60 Min', 'bis zum Ergebnis'],
];

const clerkAppearance = {
  variables: {
    colorPrimary: '#1E4FBE',
    fontFamily: FONT,
    borderRadius: '8px',
  },
  elements: {
    card: {
      boxShadow: '0 1px 3px rgba(16,22,35,0.06), 0 1px 2px rgba(16,22,35,0.04)',
      border: '1px solid #D7DCE4',
      borderRadius: '16px',
      padding: '32px 28px',
    },
    headerTitle: { fontSize: '20px', fontWeight: 700, letterSpacing: '-0.011em', color: '#101623' },
    headerSubtitle: { fontSize: '13px', color: '#667085' },
    formButtonPrimary: {
      fontSize: '13.5px',
      textTransform: 'none',
    },
    footerActionLink: { color: '#1E4FBE' },
    rootBox: { width: '100%' },
  },
};

const LoginPage = () => {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: FONT }}>

      {/* ── Sign-in panel ───────────────────────────────────────── */}
      <div style={{
        flex: '1 1 50%',
        background: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
      }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <div style={{ marginBottom: 34 }}>
            <Logo variant="lockup" height={34} />
          </div>

          <SignIn
            routing="path"
            path="/login"
            signUpUrl="/sign-up"
            forceRedirectUrl="/dashboard"
            appearance={clerkAppearance}
          />
        </div>
      </div>

      {/* ── Trust panel ─────────────────────────────────────────── */}
      <div style={{
        flex: '1 1 50%',
        background: '#0A0E17',
        color: '#fff',
        padding: 48,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(#1B2333 1px, transparent 1px)',
          backgroundSize: '22px 22px', opacity: 0.5,
        }} />

        <div style={{ position: 'relative', maxWidth: 400 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 7,
            padding: '5px 11px', border: '1px solid #2C3646', borderRadius: 999,
            fontSize: 12, fontWeight: 500, color: '#9BB6F2', marginBottom: 22,
          }}>
            <ScanLine width={14} height={14} />
            IT-Sicherheit für kleine Unternehmen
          </div>

          <h1 style={{ margin: '0 0 16px', fontSize: 30, fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.2 }}>
            Ihr Cyber-Risiko-Check nach DIN SPEC 27076
          </h1>
          <p style={{ margin: 0, fontSize: 15, color: '#B6BDC9', lineHeight: 1.6 }}>
            Melden Sie sich an, um Ihre Assessments zu verwalten und Ihren aktuellen
            IT-Sicherheitsstatus einzusehen.
          </p>

          <div style={{ display: 'flex', gap: 28, marginTop: 30 }}>
            {STATS.map(([value, label]) => (
              <div key={label}>
                <div style={{ fontFamily: FONT_MONO, fontSize: 22, fontWeight: 600 }}>{value}</div>
                <div style={{ fontSize: 12, color: '#8A93A3', marginTop: 2 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
